// extracted by mini-css-extract-plugin
export var WorkWithUsGalleryWrapper = "WorkWithUsGallery-module--WorkWithUsGalleryWrapper--7Xp2a";
export var WorkWithUsGallery = "WorkWithUsGallery-module--WorkWithUsGallery--qDGTR";
export var WorkWithUsGalleryImg = "WorkWithUsGallery-module--WorkWithUsGalleryImg--DhR26";